import React, {useState, useEffect} from 'react'
import Select from 'react-select';
import { Dialog} from '@headlessui/react'
import { Link, useNavigate} from "react-router-dom";

type PrinterTokenModalProps = {
  modal_open: boolean;
  set_modal_open: any;
  printer_name:string;
  token_data: string;
  move_url: string;
}

const PrinterTokenModal: React.FC<PrinterTokenModalProps> = (props) => {
  const navigate = useNavigate();

  const handleClose = () => {
    props.set_modal_open(false);
    navigate("/printer")
  }

  const handleCopyText = async () => {
    try {

      await navigator.clipboard.writeText(props.token_data)
      alert("クリップボードに保存しました")
    }catch (error){
      alert("クリップボードに保存失敗しました")
    }
  }

  return (
    <Dialog 
      open={props.modal_open && props.token_data !== ""} onClose={handleClose}
      className="relative z-50"
    >
      <>
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
          <div className="fixed inset-0 flex w-screen items-center justify-center p-4">

            <Dialog.Panel className="w-8/12 rounded-2xl rounded bg-white p-6">
              <Dialog.Title className="text-lg font-medium ">
                プリンター"{props.printer_name}"のトークン
              </Dialog.Title>
              <Dialog.Description>
                <div>
                  以下のトークンを必ずどこかに管理してください
                </div>
                <div className="flex">
                  <input className="border-2 rounded-l-lg text-lg grow border-blue-500"
                    value={props.token_data}
                    readOnly
                  ></input>
                  <button onClick={handleCopyText} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-r-lg inline-flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
                    </svg>
                    <span className="text-sm">トークンをコピー</span>
                  </button>

                </div>

              </Dialog.Description>
              <div className="flex mt-6">
              <button onClick={handleClose}
                className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full ml-auto mr-0"
              >Close</button>
              </div>
            </Dialog.Panel>

        </div>
      </>
    </Dialog>
  )

}

export default PrinterTokenModal